// Make sure to keep this up-to-date to prevent memo issues
export function dependencies(environmentVariables) {
  return [
    environmentVariables.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE,
    environmentVariables.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE_RELOAD,
    environmentVariables.REACT_APP_CLIENT,
    environmentVariables.REACT_APP_PROJECT_NAME,
  ];
}

export default function makeAnalyticsConfiguration(environmentVariables) {
  return {
    trackers: [{
      trackingId: environmentVariables.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE,
      gaOptions: {},
      debug: false,
    }, {
      trackingId: environmentVariables.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE_RELOAD,
      gaOptions: {},
      debug: false,
    }],
    event: {
      action: {},
      category: {
        navigation: "Navigation",
        wishlist: "Wishlist",
        hotspot: "Hotspot",
        story: "Story",
        interface: "Interface",
        socialWidget: "Social Widget",
        download: "Download",
        viewpoint: 'Viewpoint',
        effect: "Effect",
      },
    },
    client: environmentVariables.REACT_APP_CLIENT,
    project: environmentVariables.REACT_APP_PROJECT_NAME,
  };
}
